import { Link } from "react-router-dom";
import { Button } from "@mui/material";

const ForgotPasswordSuccess = ({ isMobile, heading = "Forgot password" }) => (
  <div className="auth-form">
    <p className="form-head-text">{heading}</p>
    <span className="signup-success-info">
      <p>
        <strong className="success-text">Success!</strong> If your email is
        associated with a WeddinglyAi account, we've sent a link to reset
        your password. Please check your inbox for a message from us. If you
        don't see it within a few minutes, be sure to check your spam or junk
        folder. Follow the instructions in the email to reset your password.
      </p>
    </span>
    <Link to="/" className="back-to-login">
      <Button
        type="submit"
        variant="contained"
        onClick={null}
        sx={{
          backgroundColor: isMobile ? "#F8FAE5" : "#FB4764",
          "&:hover": {
            backgroundColor: isMobile ? "#F8FAE5" : "#FB4764",
          },
          height: isMobile ? "36px" : "56px",
          fontSize: "25px",
          fontWeight: "500",
          display: "flex",
          color: isMobile ? "#292D32" : "#ffff",
          boxShadow: isMobile ? "none" : "",
          marginTop: isMobile ? "16px" : "",
          gridGap: "8px",
          textTransform: "none", // Prevent text from being all caps,
          borderRadius: "15px",
        }}
      >
        Sign in
      </Button>
    </Link>
  </div>
);

export default ForgotPasswordSuccess;
